import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export interface Profile {
  id: string;
  display_name: string | null;
  zip_code: string;
  zone: string;
}

export const profileKeys = {
  forUser: (userId: string | undefined) => ["profile", userId] as const,
};

export function useProfile() {
  const { data: session } = useAuth();
  const userId = session?.user?.id;
  return useQuery<Profile | null>({
    queryKey: profileKeys.forUser(userId),
    enabled: Boolean(userId),
    staleTime: Infinity,
    queryFn: async () => {
      if (!userId) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("id, display_name, zip_code, zone")
        .eq("id", userId)
        .maybeSingle();
      if (error) throw error;
      return data as Profile | null;
    },
  });
}
